<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="item.id ? 'Update' : 'Create'"
    :max-width="720"
    :scrollable="false"
  >
    <template slot="header">
      <span>{{ item.id ? 'Update' : 'Create' }} Project</span>
    </template>
    <template slot="body">
      <v-container
        fluid
        class="py-0"
      >
        <v-row>
          <v-col
            cols="12"
            class="pb-0"
          >
            <div class="text-caption font-weight-bold text-uppercase text--secondary">
              Project Details
            </div>
          </v-col>
        </v-row>
        <v-row>
          <!-- <v-col
            class="pb-0"
            cols="4"
          >
            <inventory-class-select-element
              v-model="item.inventory_class_id"
              :is-add-all="false"
              :auto-select-first="false"
            />
          </v-col> -->
          <v-col
            cols="12"
            class="pt-0 pb-0"
            sm="8"
          >
            <v-text-field
              v-model="item.name"
              :rules="[(v) => !!v || `Project Name is required`, (v) => !!v && v.length <= 45 || 'Max 45 characters']"
              counter="45"
            >
              <template slot="label">
                Project Name<RedAsterisk />
              </template>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            class="pt-0 pb-0"
            sm="4"
          >
            <v-text-field
              v-model="item.floor_count"
              type="number"
              min="0"
              :rules="[(v) => !!v || `Number Of Floors is required`]"
            >
              <template slot="label">
                Number Of Floors<RedAsterisk />
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            class="py-0"
          >
            <div class="text-caption font-weight-bold text-uppercase text--secondary">
              Client & Address
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            class="pt-0 pb-0"
          >
            <v-autocomplete
              v-model="item.client_id"
              :items="clients"
              item-text="name"
              item-value="id"
              :rules="[(v) => !!v || 'Client is required']"
              :loading="loadClients"
              autocomplete="preventAutocomplete"
            >
              <template slot="label">
                Client<RedAsterisk />
              </template>
            </v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            class="pt-0 pb-0"
          >
            <vuetify-google-autocomplete
              id="google"
              ref="google"
              v-model="googleAddress"
              :rules="[(v) => !!v || 'Address is required']"
              classname="form-control"
              :country="'ca'"
              @placechanged="getAddressData"
            >
              <template slot="label">
                Address<RedAsterisk />
              </template>
            </vuetify-google-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            class="py-0"
          >
            <div class="text-caption font-weight-bold text-uppercase text--secondary">
              Completion
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            sm="6"
            class="pt-0 pb-0"
          >
            <v-select
              v-model="item.completion"
              :items="completionOptions"
              item-text="text"
              item-value="value"
              label="Completion"
              clearable
              prepend-icon="mdi-progress-check"
              :attach="false"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            class="pt-0 pb-0"
          >
            <v-menu
              ref="menuCompletionDate"
              v-model="dateMenuCompletionDate"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template #activator="{ on, attrs }">
                <v-text-field
                  v-model="item.completion_date"
                  readonly
                  prepend-icon="mdi-calendar-check"
                  label="Completion Date"
                  clearable
                  v-bind="attrs"
                  v-on="on"
                  @click:clear="item.completion_date = null"
                  @change="$refs.menuCompletionDate.save(item.completion_date)"
                />
              </template>
              <v-date-picker
                v-model="item.completion_date"
                no-title
                scrollable
                @input="$refs.menuCompletionDate.save(item.completion_date)"
              >
                <v-spacer />
                <v-btn
                  text
                  color="primary"
                  @click="dateMenuCompletionDate = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="item.completion_date = null"
                >
                  Clear
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-container>
      <confirm-form ref="confirmForm" />
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';

export default {
  components: {
    VuetifyGoogleAutocomplete,
  },
  props: {

  },
  data: () => ({
    item: null,
    addressItem: null,
    googleAddress: null,
    addressDto: {
      id: 0,
      type_id: null,
      unit: null,
      building: '',
      street: '',
      city: '',
      region_id: 9,
      country_id: 1,
      postal_code: '',
      client_id: null,
    },
    itemDto: {
      id: 0,
      name: null,
      client_id: null,
      client_address_id: null,
      floor_count: null,
      completion: null,
      completion_date: null,
    },

    clients: [],
    countries: [],
    regions: [],
    completionOptions: [
      { text: '0%', value: 0 },
      { text: '25%', value: 25 },
      { text: '50%', value: 50 },
      { text: '75%', value: 75 },
      { text: '100%', value: 100 },
    ],

    loadClients: false,
    dateMenuCompletionDate: false,
    countryIdCanada: 1,
    regionIdOntario: 9,
    addressChanged: false,
  }),
  computed: {
    ...mapState({

    }),
    ...mapGetters([

    ]),
  },
  created() {
    this.item = { ...this.itemDto };
    this.resetAddressItem();
  },
  methods: {

    async get(id) {
      if (!id) return;
      const submitModel = {
        filters: {
          id,
        },
      };
      const res = await this.$api.project.read(submitModel);
      if (!res || !res.data || !res.data[0]) return;
      const firstIndex = 0;
      this.item = res.data[firstIndex];
      if (this.item.address) {
        this.addressItem = {
          ...this.addressItem,
          ...this.item.address,
        };
      }
      this.googleAddress = this.item.address_full || this.item.manual_address || null;
    },

    async getClients() {
      this.loadClients = true;
      const readModel = {
        // filters:
        // {
        //   inventory_class_id: this.item.inventory_class_id,
        // },
      };
      const res = await this.$api.client.read(readModel);
      this.clients = res.data;
      this.loadClients = false;
    },

    async getCountries() {
      this.countries = await this.$api.country.get();
    },

    async getRegions() {
      this.regions = await this.$api.region.get();
    },

    normalizeAddressField(field) {
      return field ? field.toString().trim().toLowerCase() : '';
    },

    resetAddressItem() {
      this.addressItem = { ...this.addressDto };
    },

    findCountry(countryName) {
      const normalizedCountry = this.normalizeAddressField(countryName);
      if (!normalizedCountry) return null;

      return this.countries.find((country) => (
        this.normalizeAddressField(country.name) === normalizedCountry
        || this.normalizeAddressField(country.abbreviation) === normalizedCountry
      ));
    },

    findRegion(regionNameOrCode, countryId = null) {
      const normalizedRegion = this.normalizeAddressField(regionNameOrCode);
      if (!normalizedRegion) return null;

      return this.regions.find((region) => (
        (!countryId || String(region.country_id) === String(countryId))
        && (
          this.normalizeAddressField(region.name) === normalizedRegion
          || this.normalizeAddressField(region.abbreviation) === normalizedRegion
        )
      ));
    },

    async submit() {
      if (!this.item) return false;
      const submitModel = this.buildSubmitModel();
      if (!submitModel) return false;
      let res;
      if (this.item.id) {
        res = await this.$api.project.update(submitModel);
      } else {
        res = await this.$api.project.store(submitModel);
      }

      if (!res) {
        this.$bus.$emit('showError');
        return false;
      }

      const httpStatusCodeConflict = 409;
      const httpStatusCodeNotExtended = 510;
      if (res.status === httpStatusCodeConflict || res.status === httpStatusCodeNotExtended) {
        this.$bus.$emit('showError', res.message);
        return false;
      }

      if (res.warning) {
        const confirm = await this.$refs.confirmForm.open({
          title: `${res.message}\n\n${res.projects.join('\n')}\n\nContinue anyway?`,
        });

        if (!confirm) {
          return false;
        }

        this.item.force_create = true;
        submitModel.force_create = true;

        if (this.item.id) {
          res = await this.$api.project.update(submitModel);
        } else {
          res = await this.$api.project.store(submitModel);
        }

        if (!res) {
          this.$bus.$emit('showError');
          return false;
        }

        if (res.status === httpStatusCodeConflict || res.status === httpStatusCodeNotExtended || res.warning) {
          this.$bus.$emit('showError', res.message);
          return false;
        }
      }

      delete this.item.force_create;

      this.$bus.$emit('showSuccess');
      this.$emit('success');
      return res;
    },

    async open(id) {
      this.$refs.dialogBox.open();
      this.resetAddressItem();
      if (id) {
        await this.get(id);
      } else {
        this.item = { ...this.itemDto };
        this.googleAddress = null;
      }
      this.addressChanged = false;
      this.getClients();
      await this.getCountries();
      await this.getRegions();
    },

    async getAddressData(addressData, placeData) {
      this.googleAddress = placeData.formatted_address;
      this.addressItem = this.buildAddressItem(addressData);
      this.addressChanged = true;
    },

    buildAddressItem(addressData) {
      const country = this.findCountry(addressData.country);
      const region = this.findRegion(
        addressData.administrative_area_level_1,
        country ? country.id : null,
      );

      return {
        ...this.addressItem,
        building: addressData.street_number || '',
        street: addressData.route || '',
        city: addressData.locality || addressData.administrative_area_level_2 || '',
        region_id: region ? region.id : this.regionIdOntario,
        country_id: country ? country.id : this.countryIdCanada,
        postal_code: addressData.postal_code || '',
        client_id: this.item.client_id,
      };
    },

    validateAddress() {
      const missingAddressFields = [];
      if (!this.addressItem.building) missingAddressFields.push('building number');
      if (!this.addressItem.street) missingAddressFields.push('street name');
      if (!this.addressItem.city) missingAddressFields.push('city');
      if (!this.addressItem.region_id) missingAddressFields.push('province or state');
      if (!this.addressItem.country_id) missingAddressFields.push('country');

      if (!missingAddressFields.length) return true;

      const addressErrorMessage = missingAddressFields.length === 5
        ? 'Please select an address.'
        : `Please complete the address: ${missingAddressFields.join(', ')}.`;

      this.$bus.$emit('showError', addressErrorMessage);
      return false;
    },

    buildSubmitModel() {
      const submitModel = { ...this.item };
      delete submitModel.address;

      if (this.addressChanged || (!this.item.client_address_id && !this.item.manual_address)) {
        if (!this.validateAddress()) return false;

        submitModel.address = {
          ...this.addressItem,
          client_id: this.item.client_id,
        };
        delete submitModel.manual_address;
      }

      return submitModel;
    },
  },
};
</script>

<style scoped>
/deep/#google {
  width: 100%;
}
</style>
